<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('simple.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="delete">

                <loading slot="waiting"/>

                <b-alert variant="danger" show> {{ $t('simple.delete_confirm') }}</b-alert>

            </v-wait>

          </div>

          <div class="modal-footer">
            <div v-b-tooltip.hover.right="{
                 title:!user_permissions.includes('update-team-user')? $t('permission.permission_denied', { permission: 'update-team-user' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button @click="$close(false)" variant="secondary" :class="!user_permissions.includes('update-team-user') ? 'cursor-not-allowed' : ''"
                        v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-team-user') ? $t('permission.permission_denied', { permission: 'update-team-user' }) : '', customClass: 'tooltip-dark' }"
                        :disabled="!user_permissions.includes('update-team-user')">{{ $t('simple.cancel') }}</b-button>
            </div>
            <b-button @click="user_remove" variant="primary">{{ $t('simple.delete') }}</b-button>
            
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('User Remove Modal mounted');
        },

        destroyed() {
            // Component Destroyed
            console.log('User Remove Modal destroyed.');
        },

        data: function() {
             return  {}
        },

        methods: {

            user_remove: async function(){

                // Loading start
                this.$wait.start('delete');

                // Delete user
                await axios.put('/api/v1/settings/teamuser/' + this.user_id, {
                    team_id: this.team_id,
                    role_id: this.role_id
                  }
                )
                    .then((response) => {
                        // Show success
                        Vue.toasted.success(this.$t('simple.deleted_confirmed'));


                        // Loading stop
                        this.$wait.end('delete');

                        // Close modal
                        this.$close(true);
                        //console.log(response);
                    }
                )
                    .catch((error) => {
                      // Show error
                      if (error.response && error.response.status === 403){
                        Vue.toasted.error(this.$t('permission.permission_denied',{ permission: 'update-team-user'}));
                      } else {
                        Vue.toasted.error(this.$t('simple.error_info'));
                      }
                        // Log to console
                        console.log(error);

                        // Loading stop
                        this.$wait.end('delete');

                        // Close modal
                        this.$close(true);


                    }
                );

            },
        },
      computed: {
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'
        }),
      }
    }
</script>